var _path, _path2, _path3, _path4, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnreadNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3824 11.9509L16.4339 11.4875C16.7171 8.94366 15.07 6.67259 12.7552 6.41498C10.4404 6.15737 8.33435 8.01076 8.05125 10.5547L7.99969 11.018C7.93781 11.574 7.72755 12.1009 7.39542 12.5323L6.58151 13.5895C5.83808 14.5551 6.161 16.016 7.21713 16.465C9.97997 17.6398 12.9947 17.9753 15.9482 17.4367C17.0773 17.2308 17.7135 15.8767 17.2005 14.7712L16.6389 13.561C16.4098 13.0671 16.3205 12.5069 16.3824 11.9509Z",
    fill: "#E7EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75862 18.7632C8.12477 20.2108 9.41924 21.3628 11.0711 21.5466C12.7229 21.7304 14.239 20.8912 14.9144 19.5595",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5731 11.9386L17.6392 11.3454C18.0016 8.08851 15.8929 5.18086 12.9293 4.85104C9.9656 4.52123 7.26926 6.89413 6.9068 10.1511L6.84078 10.7442C6.76156 11.4561 6.49237 12.1307 6.06714 12.683L5.02509 14.0365C4.07328 15.2728 4.48672 17.1432 5.83888 17.7181C9.37614 19.2221 13.2359 19.6517 17.0173 18.9621C18.4628 18.6986 19.2773 16.9648 18.6206 15.5495L17.9016 14.0001C17.6082 13.3678 17.4939 12.6505 17.5731 11.9386Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5312 8.42969L12.2658 10.815",
    stroke: "white",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 3.5,
    r: 2.5,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadNotifications);
export default __webpack_public_path__ + "static/media/UnreadNotifications.d30f0085ce288a643ac82487687da8b0.svg";
export { ForwardRef as ReactComponent };